export default __webpack_public_path__ + "static/media/anonymous.fcfe84d6.png";